import { Component } from 'react'

import {
  IField,
  focusField,
  updateField,
  touchField,
  touchAllFields,
  setFieldErrors
} from '@features/forms'

import { getValues } from './utils'
import { IProps } from './types'

interface IReduxFormProps {
  dispatch: any
  /** The form id in the Redux state */
  id: string
  /** The form fields in the Redux state */
  fields?: {
    [key: string]: IField
  }
}

interface ReduxForm<P = {}> {}

abstract class ReduxForm<P> extends Component<IProps & IReduxFormProps & P> {
  constructor(props: IProps & IReduxFormProps & P) {
    super(props)

    this.validate = props.validate || this.validate.bind(this)
    this.handleFieldFocus = props.onFocus || this.handleFieldFocus.bind(this)
    this.handleFieldChange = props.onChange || this.handleFieldChange.bind(this)
    this.handleFieldBlur = props.onBlur || this.handleFieldBlur.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  validate(props: any): { [key: string]: string } | null {
    return null
  }

  handleFieldFocus(name: string): void {
    let { dispatch, id } = this.props
    dispatch(focusField(id, name))
  }

  handleFieldChange(name: string, value: any): void {
    let { dispatch, id } = this.props
    dispatch(updateField(id, name, value))
  }

  handleFieldBlur(name: string): void {
    this.handleErrors()
    let { dispatch, id } = this.props
    dispatch(touchField(id, name))
  }

  touchFields(fieldNames: string[]): void {
    let { dispatch, id } = this.props
    dispatch(touchAllFields(id, fieldNames))
  }

  touchAllFields = (): void => {
    let { id, dispatch } = this.props
    let { fields } = this.props
    dispatch(touchAllFields(id, Object.keys(fields || {})))
  }

  handleErrors(): { [key: string]: string } | null {
    const { fields } = this.props
    const errors = this.validate(getValues(Object.values(fields || {})))
    let { id, dispatch } = this.props
    dispatch(setFieldErrors(id, errors))
    return errors
  }

  handleSubmit(e: any) {
    e.preventDefault()
    const { fields } = this.props
    const fieldValues = getValues(Object.values(fields || {}))
    const errors = this.handleErrors()
    if (errors) {
      this.touchAllFields()
      if (this.props.onError) {
        this.props.onError(fieldValues, errors)
      }
    } else {
      this.props.onSubmit(fieldValues)
    }

    return false
  }

  /**
   * getValues
   * Get the dict of field values mapped against their field names.
   */
  getValues = (): { [key: string]: any } => {
    return getValues(Object.values(this.props.fields || {}))
  }
}

export default ReduxForm
